import { DatePipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { CrackingRisk, ElementType, SimulationElement, SPANISH_STANDARD_MIXTURES } from '@cosmos/shared';

/**
 * List-view row for a single-element simulation — same data as
 * SimulationCardComponent, laid out horizontally. Sibling row component for
 * PaginatedEntityListComponent's list mode.
 */
@Component({
  selector: 'cosmos-simulation-row',
  imports: [DatePipe, DecimalPipe, TranslatePipe, ButtonModule, TagModule, TooltipModule],
  templateUrl: './simulation-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimulationRowComponent {
  readonly simulation = input.required<Partial<SimulationElement>>();
  readonly favouritePending = input<boolean>(false);
  readonly isLast = input<boolean>(false);

  readonly open = output<void>();
  readonly favouriteToggled = output<void>();

  protected readonly riskSeverity = computed((): 'success' | 'warn' | 'danger' | undefined => {
    switch (this.simulation().results?.overallCrackingRisk) {
      case 'LOW': return 'success';
      case 'MEDIUM': return 'warn';
      case 'HIGH': return 'danger';
      default: return undefined;
    }
  });

  protected elementLabel(type: ElementType | undefined): string {
    return type ? `simulator.element-types.${type.toLowerCase()}` : '';
  }

  protected riskLabel(risk: CrackingRisk | undefined): string {
    return risk ? `simulator.history.risk.${risk.toLowerCase()}` : '';
  }

  protected mixtureLabel(s: Partial<SimulationElement>): string {
    if (s.mixtureKey) return SPANISH_STANDARD_MIXTURES[s.mixtureKey]?.name ?? s.mixtureKey;
    return '';
  }
}
